import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

//https://www.concretepage.com/angular-2/angular-candeactivate-guard-example
@Injectable()
export class DialogService {

  private showDialogSubject = new BehaviorSubject<boolean>(null);
  private responseFromDialogSubject = new BehaviorSubject<boolean>(false);

  showDialogSubjectAsObservable = this.showDialogSubject.asObservable();
  responseFromDialogAsObservable = this.responseFromDialogSubject.asObservable();

  //TODO https://stackblitz.com/edit/angular-confirmation-dialog?file=app%2Fconfirmation-dialog%2Fconfirmation-dialog.component.ts 
  setShowDialogSubject(shouldShowDialog: boolean) {

    this.showDialogSubject.next(shouldShowDialog);

  }

  setResponseFromDialog(shouldGoToNextPage: boolean) {

    this.responseFromDialogSubject.next(shouldGoToNextPage);

  }
  
} 